import { useMemo as e } from "react";
import { validateUserHasRbacPermissions as r } from "../utils/validateUserHasRbacPermissions.js";
const i = (s) => e(() => r(s), [s]);
export {
  i as useValidateUserHasRbacPermissions
};
//# sourceMappingURL=useValidateUserHasRbacPermissions.js.map
